import moment from 'moment'

export function groupedTransFormat(tDate) {
    return moment(tDate, 'MM/D/YYYY').format('MM/DD/YY')
}

export function indTransFormat(tDate) {
    // return moment(tDate).format('[on] MMM D [at] h:mm A')
    return moment(tDate).format('[on] MMM D')
}

export function dateRangeFormat(offsetKeyDate) {
    return 'week' === offsetKeyDate.unit
        ? `Week ${moment.utc(offsetKeyDate.start).format('MM/DD')} - ${moment.utc(offsetKeyDate.end).format('MM/DD')}`
        : moment(offsetKeyDate.date, 'L').format('MMMM YYYY')
}

export function transDateFormat(tDate) {
    // return moment(tDate).format('[on] MMM D [at] h:mm A')
    return moment(tDate, 'YYYY/MM/DD').format('MMM DD YYYY')
}

export function billingPeriod(strTime, unit = 'week') {
    moment.updateLocale('en', { week: {
        dow: 6, // First day of week is Saturday
        doy: 12  // First week of year must contain 1 January (7 + 5 - 1)
    }})

    const now = moment.utc()
    const inCycle = moment.utc(strTime, 'L').isSame(now, unit)

    return {
        date: strTime,
        unit: unit,
        inCycle: inCycle,
        weekNum: moment.utc(strTime, 'L').week(),
        start: moment.utc(strTime, 'L').startOf(unit).toISOString(),
        end: inCycle ? now.toISOString() : moment.utc(strTime, 'L').endOf(unit).toISOString()
    }
}

export function weeklyPeriod(strTime, pastPeriod = 0) {
    moment.updateLocale('en', { week: {
        dow: 6, // First day of week is Saturday
        doy: 12  // First week of year must contain 1 January (7 + 5 - 1)
    }})

    return {
        date: strTime,
        weekNum: moment.utc(strTime, 'L').subtract(pastPeriod, 'week').week(),
        start: moment.utc(strTime, 'L').subtract(pastPeriod, 'week').startOf('week').toISOString(),
        end: moment.utc(strTime, 'L').subtract(pastPeriod, 'week').endOf('week').toISOString()
    }
}

export function weeklyPeriodFormat(weeklyDate) {
    return `${moment.utc(weeklyDate.start).format('MMM DD YYYY')} - ${moment.utc(weeklyDate.end).format('MMM DD YYYY')}`
}

export function momentDiff(strTime, endTime = 'now', timePeriod = 'seconds') {
    if ('now' === endTime || 'undefined' === typeof endTime) {
        return moment().diff(moment(strTime), timePeriod)
    } else {
        return moment(endTime).diff(moment(strTime), timePeriod)
    }
}

export function momentDiffInWeeks(strTime, endTime = 'now') {
    let diff = momentDiff(strTime, endTime, 'seconds')
    let relativeTime

    switch (true) {
        case diff < 60:
            relativeTime = diff + 's'
            break

        case diff >= 60 && diff < 3600:
            relativeTime = ~~(diff/60) + 'm'
            break

        case diff >=3600 && diff < 86400:
            relativeTime = ~~(diff/3600) + 'h'
            break

        case diff >=86400 && diff < 604800:
            relativeTime = ~~(diff/86400) + 'd'
            break

        case diff >=604800 && diff < 31449600:
            relativeTime = ~~(diff/604800) + 'w'
            break

        case diff >=31449600:
        default:
            relativeTime = ~~(diff/31449600) + 'y'
            break

    }

    return relativeTime
}



// WEBPACK FOOTER //
// ./src/lib/momentHelpers.js